import { IconRefresh } from './icons.js';
import type { ReplyFailureKind } from './hooks/useReplyFailure.js';

interface ReplyFailedCardProps {
  kind: ReplyFailureKind;
  /** Vuelve a pedir la respuesta (el user no repite nada). */
  onRetry: () => void;
  onLeave: () => void;
}

/**
 * "El coach no pudo responder": el reply falló (aviso `reply_failed` del
 * server) o el "pensando" pasó el tope de espera. Va al FINAL del hilo, debajo
 * del mensaje que quedó sin respuesta — misma pieza que el cierre de la charla
 * (`.conn-banner-lost`). La sesión sigue viva: el user también puede seguir
 * hablando o escribiendo, y la tarjeta se va sola.
 */
export function ReplyFailedCard({ kind, onRetry, onLeave }: ReplyFailedCardProps) {
  const opener = kind === 'opener';
  return (
    <div className="conn-banner conn-banner-lost session-ended-card" role="alert">
      <div className="conn-lost-text">
        <strong>
          {opener ? 'El coach no pudo arrancar la charla' : 'El coach no pudo responder'}
        </strong>
        <span>
          {opener
            ? 'Fue un problema nuestro, no de tu conexión ni de tu micrófono. Probá de nuevo en un momento.'
            : 'Tu mensaje llegó, pero hubo un problema nuestro. Tocá Reintentar y el coach te contesta.'}
        </span>
      </div>
      <div className="conn-lost-actions">
        <button type="button" className="conn-btn conn-btn-primary" onClick={onRetry}>
          <IconRefresh size={14} /> Reintentar
        </button>
        <button type="button" className="conn-btn conn-btn-ghost" onClick={onLeave}>
          Volver
        </button>
      </div>
    </div>
  );
}
